import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=05d52e31&scoped=true"
import script from "./CandidateList.vue?vue&type=script&lang=js"
export * from "./CandidateList.vue?vue&type=script&lang=js"
import style0 from "./CandidateList.vue?vue&type=style&index=0&id=05d52e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d52e31",
  null
  
)

export default component.exports